import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "nav-glass border-b border-[#E7E5E4]/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="/"
            className="flex items-center gap-2"
            data-testid="logo"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_quality-builds-11/artifacts/nrr9sqei_Untitled%20design%20%283%29.png"
              alt="JV Home Renovation Logo"
              className="h-16 md:h-20 w-auto transition-all"
              style={{ 
                filter: isScrolled ? 'none' : 'brightness(0) invert(1)'
              }}
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("services")}
              className={`text-sm font-medium transition-colors hover:text-[#166534] ${
                isScrolled ? "text-[#57534E]" : "text-white/80 hover:text-white"
              }`}
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("gallery")}
              className={`text-sm font-medium transition-colors hover:text-[#166534] ${
                isScrolled ? "text-[#57534E]" : "text-white/80 hover:text-white"
              }`}
              data-testid="nav-gallery"
            >
              Our Work
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className={`text-sm font-medium transition-colors hover:text-[#166534] ${
                isScrolled ? "text-[#57534E]" : "text-white/80 hover:text-white"
              }`}
              data-testid="nav-about"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection("quote")}
              className="bg-[#166534] hover:bg-[#14532D] text-white px-6 py-2 rounded-none font-medium"
              data-testid="nav-quote-btn"
            >
              Get a Free Quote
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 ${
              isScrolled ? "text-[#1C1917]" : "text-white"
            }`}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden bg-white border-t border-[#E7E5E4]"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 space-y-4">
            <button
              onClick={() => scrollToSection("services")}
              className="block w-full text-left text-[#1C1917] font-medium py-2"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("gallery")}
              className="block w-full text-left text-[#1C1917] font-medium py-2"
            >
              Our Work
            </button>
            <button
              onClick={() => scrollToSection("about")}
              className="block w-full text-left text-[#1C1917] font-medium py-2"
            >
              About
            </button>
            <Button
              onClick={() => scrollToSection("quote")}
              className="w-full bg-[#166534] hover:bg-[#14532D] text-white rounded-none font-medium"
            >
              Get a Free Quote
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
